import { useSyncExternalStore } from "react";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function getMediaQuery(): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }

  return window.matchMedia(REDUCED_MOTION_QUERY);
}

function getSnapshot(): boolean {
  return getMediaQuery()?.matches ?? false;
}

function subscribe(onStoreChange: () => void): () => void {
  const mediaQuery = getMediaQuery();

  if (!mediaQuery) {
    return () => undefined;
  }

  mediaQuery.addEventListener("change", onStoreChange);

  return () => mediaQuery.removeEventListener("change", onStoreChange);
}

export function usePrefersReducedMotion(override?: boolean): boolean {
  const prefersReducedMotion = useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => false
  );

  return override ?? prefersReducedMotion;
}
